import React from "react";
// mui 5
import Grid from "@mui/material/Grid";
// custom components
import PokemonCardHome from "../PokemonCardHome";
import ErrorMessage from "../CommonComponents/ErrorMessage";
// custom hooks
import useGetAllPokemon from "./hooks/useGetAllPokemon";
// styled components
import {  StyledPokemons } from "./styledComponents";

function Pokemons() {
  // custom hook
  const { data, isLoading, isError, isSuccess } = useGetAllPokemon();

  // wait for all pokemons to load
  if (isLoading) {
    return <ErrorMessage msg="Loading pokemons..." />;
  }
  // show error
  if (isError) {
    return <ErrorMessage msg="Sorry could not load pokemons" />;
  }

  // empty collection message
  if (isSuccess && data.length === 0) {
    return <ErrorMessage msg="No pokemons in collection" />;
  }

  return (
    <StyledPokemons>
      <Grid container spacing={2}>
        {data.map((pokemon) => (
          <Grid item key={pokemon.id} xs={12} sm={6} md={4}>
            <PokemonCardHome pokemon={pokemon} />
          </Grid>
        ))}
      </Grid>
    </StyledPokemons>
  );
}

export default Pokemons;
